import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import { BEM, renderClassName } from '@feedfm/feed-util';

import './VolumeControl.scss';

const bem = new BEM( 'echo-chamber' );
interface VolumeControlProps {
  onVolumeChange: ( volume: number ) => void;
}

export const VolumeControl: React.FC<VolumeControlProps> = ( { onVolumeChange } ) => {
  const initialVolume = localStorage.getItem( 'volume' ) ? parseFloat( localStorage.getItem( 'volume' )! ) : 1;
  const [unmutedVolume, setUnmutedVolume] = useState<number | null>( null );
  const [volume, setVolume] = useState<number>( initialVolume );
  const sliderEl = document.querySelector( '.volume-control input' ) as HTMLInputElement;

  useEffect( () => {
    onVolumeChange( volume );
    localStorage.setItem( 'volume', volume.toString() );
    if ( sliderEl ) {
      const progress = ( volume / 1 ) * 100;
      sliderEl.style.background = `linear-gradient(to right, #fff ${progress}%, #ccc ${progress}%)`;
    }
  }, [volume, onVolumeChange, sliderEl] );

  const toggleMute = () => {
    if ( volume === 0 ) {
      setVolume( unmutedVolume || 1.0 );
    } else {
      setUnmutedVolume( volume );
      setVolume( 0.0 );
    }
  };

  const handleVolumeChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {
    setVolume( parseFloat( event.target.value ) );
  };

  return (
    <div className={ renderClassName( bem.el( 'volume-controls' ) ) }>
      { volume === 0 ? (
        <button className="control-btn" onClick={ toggleMute }>
          { ' ' }
          <FontAwesomeIcon icon={ faVolumeMute } onClick={ toggleMute } />{ ' ' }
        </button>
      ) : (
        <button className="control-btn" onClick={ toggleMute }>
          { ' ' }
          <FontAwesomeIcon icon={ faVolumeUp } onClick={ toggleMute } />{ ' ' }
        </button>
      ) }
      <div className={ renderClassName( bem.el( 'volume-control' ) ) }>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={ volume }
          onChange={ handleVolumeChange }
          className="volume-slider"
        />
      </div>
    </div>
  );
};
